import { IntegrityMonitorDefaultRuleConfigurationBaseDataProvider } from './IntegrityMonitorDefaultRuleConfigurationBaseDataProvider';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { IntegrityMonitorAssignationData } from '../types';

export class IntegrityMonitorDefaultRuleConfigurationGzDataProvider extends IntegrityMonitorDefaultRuleConfigurationBaseDataProvider {
  public async getRuleAssignationData(ruleSetIds: Array<string>): Promise<IntegrityMonitorAssignationData> {
    try {
      const ruleSetsIdentifiers =
        await this.dependencies.api.clients.IntegrityMonitorRuleSets.getRuleSetIdentifiersByIds({
          ruleSetIds,
          companyId: this.dependencies.getActiveCompany().companyId,
        }).toPromise();

      const policiesIdentifiers =
        await this.dependencies.api.clients.IntegrityMonitorRuleSets.getPoliciesIdentifiersByRuleSetIds({
          ruleSetIds,
          companyId: this.dependencies.getActiveCompany().companyId,
        }).toPromise();

      return sanitizeObject({
        ruleSets: ruleSetsIdentifiers.data,
        policies: policiesIdentifiers.data,
      });
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async configureDefaultRule(ruleData: IntegrityMonitorRuleGridItem): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorRules.configureDefaultRule(
        ruleData
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
